import { createSelector } from 'reselect';
import omit from 'lodash/omit.js';

const productInfoNonDefaultSelector = createSelector(
  state => state.productInfo,
  productInfo => omit(productInfo, ['DefaultProduct']),
);

export default productInfoNonDefaultSelector;
